export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_recipe-calculator-21/artifacts/79wsrpnr_foodcost.png";

export const INGREDIENT_CATEGORIES = [
    // Solidi base
    "carne",
    "pesce",
    "verdure",
    "frutta",
    "latticini",
    "farine",
    "cereali",
    "oli",
    "spezie",
    "dispensa",
    "dolci",
    // Bevande DETTAGLIATE (v23.27 — niente "bevande" / "distillato" / "vino" generici)
    "acqua",
    "acqua tonica",
    "rhum",
    "gin",
    "vodka",
    "whisky",
    "tequila",
    "mezcal",
    "cognac",
    "brandy",
    "grappa",
    "sake",
    "liquore",
    "amaro",
    "bitter",
    "vermouth",
    "vino bianco",
    "vino rosso",
    "vino rosato",
    "vino frizzante",
    "vino fortificato",
    "spumante",
    "champagne",
    "prosecco",
    "birra",
    "birra artigianale",
    "sidro",
    "soft drink",
    "energy drink",
    "tonica",
    "soda",
    "mixer",
    "succhi",
    "sciroppi",
    "caffè",
    "tè",
    "tisana",
    "latte",
    "panna",
    "yogurt",
    "frutta fresca",
    "erbe",
    "analcolico",
    "altro",
];

export const BEVERAGE_CATEGORIES = [
    // Acqua
    "Acqua",
    "Acqua tonica",
    // Distillati DETTAGLIATI (nessuna macro "Distillato")
    "Rhum",
    "Gin",
    "Vodka",
    "Whisky",
    "Tequila",
    "Mezcal",
    "Cognac",
    "Brandy",
    "Grappa",
    "Sake",
    "Aquavit",
    // Liquori
    "Liquore",
    "Amaro",
    "Bitter",
    "Vermouth",
    // Vini DETTAGLIATI (nessun "Vino" generico)
    "Vino bianco",
    "Vino rosso",
    "Vino rosato",
    "Vino frizzante",
    "Vino dolce",
    "Vino fortificato",
    "Spumante",
    "Champagne",
    "Prosecco",
    // Birre
    "Birra",
    "Birra artigianale",
    "Sidro",
    // Soft & mixer
    "Soft drink",
    "Energy drink",
    "Tonica",
    "Soda",
    "Mixer",
    "Succhi",
    "Sciroppi",
    // Caffetteria
    "Caffè",
    "Tè",
    "Tisana",
    "Latte",
    "Panna",
    "Yogurt",
    // Frutta/Erbe (granulari)
    "Frutta fresca",
    "Erbe",
    "Spezie",
    // Altro
    "Analcolico",
    "Altro",
];

export const RECIPE_CATEGORIES = [
    "Antipasti",
    "Primi",
    "Secondi",
    "Contorni",
    "Pizze",
    "Dolci",
    "Bevande",
];

export const CATEGORY_COLORS = {
    carne: "#d32f2f",
    pesce: "#1976d2",
    verdure: "#2e7d32",
    latticini: "#fbc02d",
    farine: "#f57c00",
    cereali: "#8d6e63",
    spezie: "#c2185b",
    oli: "#c0ca33",
    bevande: "#0288d1",
    dispensa: "#757575",
    dolci: "#d81b60",
    frutta: "#f06292",
};

// Colori dedicati alle categorie dei piatti (diverse da quelle degli ingredienti)
export const RECIPE_CATEGORY_COLORS = {
    Antipasti: "#c9a961",
    Primi: "#1976d2",
    Secondi: "#d32f2f",
    Contorni: "#2e7d32",
    Pizze: "#ed6c02",
    Dolci: "#d81b60",
    Bevande: "#0288d1",
};

export const UNITS = ["kg", "g", "l", "ml", "pz"];

export function catColor(cat) {
    return CATEGORY_COLORS[cat] || "#6b7280";
}

export function recipeCatColor(cat) {
    return RECIPE_CATEGORY_COLORS[cat] || "#c9a961";
}

export function catLabel(cat) {
    if (!cat) return "";
    return cat.charAt(0).toUpperCase() + cat.slice(1);
}

export function foodCostColor(pct) {
    if (!pct || pct <= 0) return "#6b7280";
    if (pct < 30) return "#2e7d32";
    if (pct < 35) return "#ed6c02";
    return "#d32f2f";
}

export function foodCostTextClass(pct) {
    if (!pct || pct <= 0) return "text-brand-muted";
    if (pct < 30) return "text-brand-success";
    if (pct < 35) return "text-brand-warning";
    return "text-brand-danger";
}

export function euro(n) {
    const v = Number(n || 0);
    return v.toLocaleString("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function euroPrecise(n) {
    const v = Number(n || 0);
    return v.toLocaleString("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
    });
}


/**
 * Normalizza una quantità per la visualizzazione: se è espressa in `g` o `ml`
 * e supera la soglia di 1000, viene convertita in `kg` o `l`. Solo per display
 * — NON modificare i dati salvati o i campi input editabili dall'utente.
 */
export function normalizeQty(qty, unit) {
    const q = Number(qty) || 0;
    if (unit === "g" && q >= 1000) return { qty: q / 1000, unit: "kg" };
    if (unit === "ml" && q >= 1000) return { qty: q / 1000, unit: "l" };
    return { qty: q, unit: unit || "" };
}

/**
 * Stesso comportamento di `normalizeQty` ma restituisce una stringa pronta
 * per il render (es. "1,5 kg", "300 g", "2 pz"). I trailing zero vengono
 * rimossi e i decimali sono al massimo 3.
 */
export function formatQty(qty, unit) {
    const f = normalizeQty(qty, unit);
    const fixed = parseFloat(f.qty.toFixed(3));
    const txt = fixed.toLocaleString("it-IT", { maximumFractionDigits: 3 });
    return `${txt} ${f.unit}`.trim();
}
